export const translations = {
    events: 'Dogodki',
    events2: 'Dogodke',
    articles: 'Novice',
    shows: 'Oddaje',
    episodes: 'Epizode',
    episodeNumber: 'Številka epizode',
    manageEpisodes: 'Upravljaj epizode',
    projects: 'Projekti',
    projects2: 'Projekte',
    save: 'Shrani',
    title: 'Naslov',
    date: 'Datum',
    dateRequired: 'Datum *',
    type: 'Tip',
    author: 'Avtor',
    url: 'Link',
    description: 'Opis',
    content: 'Vsebina',
    shortContent: 'Kratka vsebina',
    insertContent: 'Dodaj novo',
    editContent: 'Spremeni',
    username: 'Uporabniško ime',
    password: 'Geslo',
    login: 'Prijavi se',
    light: 'Svetlo',
    dark: 'Temno',
    where: 'Kje',
    when: 'Kdaj',
    what: 'Kaj',
    aboutUs: 'O nas',
    find: 'Išči',
    showList: 'Seznam oddaj',
    file: 'File',
    uploadNewImage: 'Naloži novo sliko',
    imageUploaded: 'Slika uspešno naložena',
    publish: 'Objavi?',
};

export const links = {
    articles: '/novice',
    events: '/dogodki',
    shows: '/oddaje',
    projects: '/projekti',
    about: '/o-nas',
};
